import { NavLink } from "react-router-dom";
import ComprarEntradas from "../components/evento/ComprarEntradas";
import { useState } from "react";
import { PATH_EVENTO_PRODUCTION } from "../../const/PATH";
import OfComprarEntradas from "../components/evento/OfComprarEntradas";
import { upcomingDate } from "../../utils/EventoUtils";
import { Helmet } from "react-helmet-async";
import SelectEntrada from "../utils/SelectEntrada";
import Alerts from "../../web/components/Alerts/Alerts";

const Entrada = ({
  setStep,
  step,
  entradas,
  onClick,
  comission,
  form,
  evento,
  label,
  me,
  membresia,
  loading,
  stock,
  slug,
  asientosSeleccionados,
  setAsientosSeleccionados
}) => {
  const [image, setImage] = useState(
    `${PATH_EVENTO_PRODUCTION}${evento?.imagen}`
  );
  const manejarError = () => {
    setImage("/assets/img/eventos/imageNotFound.svg");
  };

  const handleShare = () => {
    const currentUrl = window.location.href;

    navigator.clipboard.writeText(currentUrl).then(() => {
      Alerts({
        msg: "Éxito",
        title: "URL copiada al portapapeles",
        code: "200",
        type: "success",
      });
    }).catch((err) => {
      Alerts({
        msg: "Error",
        title: "No se pudo copiar la URL",
        code: "400",
        type: "error",
      });
    });
  };

  const handleDateChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    onClick(e, {
      select: e.target.value,
      stock: selectedOption.getAttribute("data-stock"),
      hora: selectedOption.getAttribute("data-hora"),
    });
  };

  const getButtonConfig = () => {
    if (evento?.status === 2) {
      return {
        text: "EVENTO PAUSADO",
        className: "btn-secondary text-white",
        disabled: true
      };
    }
    if (!stock) {
      return {
        text: "Entradas agotadas",
        className: "btn-custom-naranja text-white",
        disabled: true
      };
    }
    return {
      text: "COMPRAR ENTRADAS",
      className: "btn-custom-amarillo",
      disabled: !form.fecha
    };
  };

  const buttonConfig = getButtonConfig();

  const fichaTecnica = (ficha_tecnica) => {
    const data = typeof ficha_tecnica === "string" ? JSON.parse(ficha_tecnica) : ficha_tecnica;

    return Object.keys(data).map((key, index) => (
      <div className="mb-3" key={index}>
        <small className="text-muted text-uppercase d-block mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
          {key}
        </small>
        <div className="fw-bold" style={{ fontSize: '14px' }}>
          {data[key]}
        </div>
      </div>
    ));
  };

  const links = (linksData) => {
    const data = typeof linksData === "string" ? JSON.parse(linksData) : linksData;

    const getIconForLink = (key) => {
      const lowerKey = key.toLowerCase();
      if (lowerKey.includes('instagram')) return 'bi-instagram';
      if (lowerKey.includes('facebook')) return 'bi-facebook';
      if (lowerKey.includes('youtube')) return 'bi-youtube';
      if (lowerKey.includes('twitter') || lowerKey.includes('x.com')) return 'bi-twitter';
      return 'bi-link-45deg';
    };

    return (
      <div className="d-flex gap-3">
        {Object.keys(data).map((key, index) => (
          <a
            key={index}
            href={data[key]}
            className="btn btn-outline-dark rounded-circle d-flex align-items-center justify-content-center"
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '40px', height: '40px', padding: '0' }}
            title={key}
          >
            <i className={`bi ${getIconForLink(key)}`} style={{ fontSize: '18px' }}></i>
          </a>
        ))}
      </div>
    );
  };

  const EventImage = ({ isMobile = false }) => (
    <div
      className={`overflow-hidden ${isMobile ? 'border mb-3' : ''}`}
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "100%",
        borderRadius: isMobile ? '12px' : '0'
      }}
    >
      <img
        src={image}
        alt={evento.nombre}
        onError={manejarError}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      {evento?.status === "PAUSADO" && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <h2
            className="Grifter text-white text-center px-3"
            style={{
              fontSize: isMobile ? "1.8rem" : "2.5rem",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            EVENTO PAUSADO
          </h2>
        </div>
      )}
    </div>
  );

  return (
    <main className="m-0 min-vh-100" style={{ paddingTop: "100px" }}>
      <Helmet>
        {/* Open Graph (Facebook, LinkedIn, Instagram, WhatsApp) */}
        <meta property="og:title" content={evento?.nombre} />
        <meta property="og:description" content={evento?.descripcion?.replace(/<[^>]*>/g, '').substring(0, 200)} />
        <meta property="og:image" content={`${PATH_EVENTO_PRODUCTION}${evento?.imagen}`} />
        <meta property="og:image:secure_url" content={`${PATH_EVENTO_PRODUCTION}${evento?.imagen}`} />
        <meta property="og:image:width" content="1080" />
        <meta property="og:image:height" content="1080" />
        <meta property="og:image:alt" content={evento?.nombre} />
        <meta
          property="og:url"
          content={`https://antesala.com/entrada/${evento?.slug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={"Antesala"} />
        <meta property="og:locale" content="es_ES" />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={evento?.nombre} />
        <meta name="twitter:description" content={evento?.descripcion?.replace(/<[^>]*>/g, '').substring(0, 200)} />
        <meta name="twitter:image" content={`${PATH_EVENTO_PRODUCTION}${evento?.imagen}`} />
        <meta name="twitter:site" content="@MiCuentaTwitter" />

        {/* Título dinámico */}
        <title>{evento?.nombre}</title>
      </Helmet>
      <section className="bg-gris-claro pt-4 pb-5 w-100">
        <div className="container-md">
          <div className="row">
            {/* Imagen Desktop */}
            <div className="col-md-6 mb-3 wow bounceInLeft d-none d-md-block">
              <EventImage />
            </div>

            <div className="col-md-6 mb-3">
              {/* Categorías */}
              <div className="mb-2">
                {evento?.categorias.map((categoria, index) => (
                  <span
                    key={index}
                    className="badge bg-naranja text-white text-uppercase px-2 py-1 me-2 mb-2"
                    style={{ fontSize: "10px", fontWeight: '600', letterSpacing: '0.5px' }}
                  >
                    {categoria.nombre}
                  </span>
                ))}
              </div>

              {/* Título */}
              <h1 className="Grifter GothamBold text-uppercase mb-1 wow bounceInUp" style={{ fontSize: '28px', lineHeight: '1.2' }}>
                {evento.nombre}
              </h1>
              {evento.nombre_grupo && evento.nombre_grupo !== 'null' && (
                <h2 className="Grifter text-uppercase mb-3 wow bounceInUp" style={{ fontSize: '16px', color: '#666' }}>
                  ({evento.nombre_grupo})
                </h2>
              )}

              {/* Imagen Mobile */}
              <div className="d-block d-md-none mb-3">
                <EventImage isMobile={true} />
              </div>

              {/* Fecha - Desktop */}
              <div className="d-none d-md-block mb-3">
                <label className="fw-bold d-block mb-2" style={{ fontSize: "12px" }}>
                  Fecha
                </label>
                <select
                  className="form-select"
                  aria-label="Seleccionar fecha"
                  name="add-date"
                  onChange={handleDateChange}
                >
                  <option value="">Selecciona una fecha</option>
                  {evento.fechasJSON.map((json, jsonIndex) =>
                    json.fechas.map((fecha, fechaIndex) =>
                      upcomingDate(fecha, json.hora) && (
                        <option
                          key={`${jsonIndex}-${fechaIndex}`}
                          value={fecha}
                          data-stock={json.stock}
                          data-hora={json.hora}
                        >
                          {`${fecha} Hora: ${json.hora}`}
                        </option>
                      )
                    )
                  )}
                </select>
              </div>

              {/* Sala */}
              <div className="mb-3">
                <label className="fw-bold d-block mb-2" style={{ fontSize: "12px" }}>
                  Sala
                </label>
                <div className="d-flex align-items-center">
                  <i className="bi bi-buildings me-2" style={{ fontSize: '14px' }}></i>
                  <span className="text-uppercase" style={{ fontSize: '14px' }}>
                    {evento.nombre_sitio}
                  </span>
                </div>
              </div>

              {/* Dirección */}
              <div className="mb-3">
                <label className="fw-bold d-block mb-2" style={{ fontSize: "12px" }}>
                  Dirección
                </label>
                <div className="d-flex align-items-start">
                  <i className="bi bi-geo-alt-fill me-2 mt-1" style={{ fontSize: '14px' }}></i>
                  <span className="text-uppercase" style={{ fontSize: '14px', lineHeight: '1.4' }}>
                    {`${evento.direccion}, ${evento.localidad} ${evento.provincia}`}
                  </span>
                </div>
              </div>

              {/* Precio */}
              <div className="mb-3">
                <label className="fw-bold d-block mb-2" style={{ fontSize: "12px" }}>
                  PRECIO POR ENTRADA
                </label>
                <div className="fw-bold text-custom-naranja" style={{ fontSize: '28px' }}>
                  {SelectEntrada(evento?.entradas)}
                </div>
                <small className="text-muted d-none">+ cargos por servicio <i className="bi bi-info-circle"></i></small>
              </div>

              {/* Botones Desktop */}
              {evento?.status === 2 ? (
                <button
                  className="d-none d-md-block btn btn-secondary text-white Grifter py-3 w-100 disabled"
                  style={{ borderRadius: "10px" }}
                  type="button"
                  disabled
                >
                  {me ? "EVENTO PAUSADO" : "EVENTO PAUSADO"}
                </button>
              ) : stock ? (
                <button
                  className={`d-none d-md-block btn btn-custom-amarillo Grifter py-3 w-100 ${form.fecha ? "" : "disabled"}`}
                  style={{ borderRadius: "10px" }}
                  onClick={() => !me && (window.location.href = "/login")}
                  type={me ? "button" : "button"}
                  data-bs-toggle={me ? "modal" : ""}
                  data-bs-target={me ? "#exampleModal" : ""}
                  id={me ? "modal-comprar-entradas" : ""}
                >
                  {me ? "Comprar entradas" : "Comprar entradas"}
                </button>
              ) : (
                <button
                  className="d-none d-md-block btn btn-custom-naranja text-white Grifter py-3 w-100"
                  style={{ borderRadius: "10px" }}
                  type="button"
                >
                  Entradas agotadas
                </button>
              )}

              {
                <ComprarEntradas
                  setStep={setStep}
                  step={step}
                  entradas={entradas}
                  onClick={onClick}
                  comission={comission}
                  form={form}
                  evento={evento}
                  fechas={evento?.fechasJSON ?? []}
                  label={label}
                  image={image}
                  me={me}
                  loading={loading}
                  asientosSeleccionados={asientosSeleccionados}
                  setAsientosSeleccionados={setAsientosSeleccionados}
                />
              }

              {
                <OfComprarEntradas
                  setStep={setStep}
                  step={step}
                  entradas={entradas}
                  onClick={onClick}
                  comission={comission}
                  form={form}
                  evento={evento}
                  fechas={evento?.fechasJSON ?? []}
                  label={label}
                  image={image}
                  me={me}
                  setmembresia={membresia}
                  loading={loading}
                  asientosSeleccionados={asientosSeleccionados}
                  setAsientosSeleccionados={setAsientosSeleccionados}
                />
              }
            </div>

            {/* Botón compartir */}
            <div className="col-12 mb-3 d-none d-md-block">
              <button
                onClick={handleShare}
                className="btn btn-outline-dark py-2 px-3"
                style={{ borderRadius: "20px", fontSize: '14px' }}
              >
                <i className="bi bi-share me-2"></i>
                Compartir
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Barra fija inferior para mobile */}
      <div
        className="d-md-none position-fixed bottom-0 start-0 w-100 bg-white shadow-lg"
        style={{
          zIndex: 1044,
          borderTop: '2px solid #dee2e6'
        }}
      >
        <div className="p-3">
          {/* Selector de fecha mobile */}
          <div className="mb-3">
            <label className="fw-bold d-block mb-2 text-muted" style={{ fontSize: "12px" }}>
              Selecciona una fecha
            </label>
            <select
              className="form-select"
              aria-label="Seleccionar fecha"
              name="add-date"
              onChange={handleDateChange}
            >
              <option value="">Selecciona una fecha</option>
              {evento.fechasJSON.map((json, jsonIndex) =>
                json.fechas.map((fecha, fechaIndex) =>
                  upcomingDate(fecha, json.hora) && (
                    <option
                      key={`${jsonIndex}-${fechaIndex}`}
                      value={fecha}
                      data-stock={json.stock}
                      data-hora={json.hora}
                    >
                      {`${fecha} Hora: ${json.hora}`}
                    </option>
                  )
                )
              )}
            </select>
          </div>

          {/* Precio y botón */}
          <div className="">
            <div className="flex-grow-1 mb-2">
              <div className="d-flex align-items-center gap-2">
                <span className="text-custom-naranja fw-bold" style={{ fontSize: '16px' }}>
                  <span className="text-muted" style={{ fontSize: '12px' }}>Entradas desde</span> {SelectEntrada(evento?.entradas)}
                </span>
              </div>
            </div>
            <div style={{ minWidth: '120px' }}>
              {evento?.status === 2 ? (
                <button
                  className="btn btn-secondary text-white Grifter py-2 w-100 disabled"
                  style={{ borderRadius: "10px", fontSize: '11px' }}
                  type="button"
                  disabled
                >
                  PAUSADO
                </button>
              ) : stock ?
                me ?
                  (
                    <button
                      className={`w-100 btn btn-primary Grifter py-2 w-100 ${form.fecha ? "" : "disabled"}`}
                      style={{ borderRadius: "10px", fontSize: '14px' }}
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasTop-comprar-entradas"
                      aria-controls="offcanvasTop-comprar-entradas"
                    >
                      Comprar
                    </button>
                  ) : (
                    <button
                      className="btn btn-custom-amarillo Grifter py-2 w-100"
                      style={{ borderRadius: "10px", fontSize: '14px' }}
                      onClick={() => (window.location.href = "/login")}
                    >
                      Ingresar
                    </button>
                  ) : (
                  <button
                    className="btn btn-custom-naranja text-white Grifter py-2 w-100"
                    style={{ borderRadius: "10px", fontSize: '12px' }}
                    type="button"
                  >
                    Entradas agotadas
                  </button>
                )}
            </div>
          </div>
        </div>
      </div>

      {/* Sección de detalles */}
      <section className="py-5 bg-white" style={{ paddingBottom: '160px' }}>
        <div className="container">
          <div className="row">
            {/* Descripción */}
            <div className="col-12 col-md-6 mb-4">
              <h3 className="text-uppercase fw-bold mb-4" style={{ fontSize: '18px', letterSpacing: '1px' }}>
                SOBRE EL EVENTO
              </h3>
              <div
                className="content-description"
                style={{ fontSize: '15px', lineHeight: '1.8', color: '#333' }}
                dangerouslySetInnerHTML={{ __html: evento.descripcion }}
              ></div>
            </div>

            <div className="col-12 col-md-6 mb-4">
              {/* Ficha técnica */}
              {evento.ficha_tecnica && (
                <div>
                  <h3 className="text-uppercase fw-bold mb-4" style={{ fontSize: '18px', letterSpacing: '1px' }}>
                    FICHA TÉCNICA
                  </h3>
                  <div style={{ fontSize: '14px', lineHeight: '1.8', color: '#333' }}>
                    {fichaTecnica(evento.ficha_tecnica)}
                  </div>
                </div>
              )}
              {/* Links */}
              {evento.link && (
                <div className="">
                  <h3 className="text-uppercase fw-bold mb-4" style={{ fontSize: '18px', letterSpacing: '1px' }}>
                    LINKS
                  </h3>
                  {links(evento.link)}
                </div>
              )}
            </div>

          </div>
        </div>
      </section>

      {/* Sección de ubicación */}
      <section className="py-5 border-top">
        <div className="container">
          <div className="text-center mb-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div></div>
              <div className="text-md-end">
                <p className="mb-1 fw-bold">{evento?.nombre_sitio}</p>
                <p className="mb-1">{`${evento.direccion}, ${evento.localidad} ${evento.provincia}`}</p>
                {evento?.email_sitio && <p className="mb-1">{evento.email_sitio}</p>}
                {evento?.telefono_sitio && <p className="mb-1">{evento.telefono_sitio}</p>}
              </div>
            </div>
          </div>
          <div className="w-100">
            <iframe
              src={
                "https://maps.google.com/?q=" +
                encodeURI(
                  `${evento.direccion}, ${evento.localidad} ${evento.provincia}`
                ) +
                "&z=14&t=m&output=embed"
              }
              style={{ border: "0", width: '100%', height: '400px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Entrada;
